export default __webpack_public_path__ + "static/media/hero-bg-d.4ba79452.jpg";